import { useContext, useEffect, useRef, useState } from 'react'
import { ThemeContext } from '../../contexts/theme'
import { CloseIcon, MenuIcon, MoonIcon, SunIcon } from '../Icons/Icons'
import plainResumePdf from '../../files/Zachary_Toliver_Resume.pdf'
import { jobs, educationList, skills, tools, contact } from '../../portfolio'
import './Navbar.css'

const Navbar = () => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext)
  const [showNavList, setShowNavList] = useState(false)
  const [showResumeMenu, setShowResumeMenu] = useState(false)
  const resumeMenuRef = useRef(null)
  const firstResumeLinkRef = useRef(null)
  const fancyResumePath = `${process.env.PUBLIC_URL || ''}/fancy-resume.html`
  const resumeMenuId = 'resume-menu'

  const toggleNavList = () => {
    setShowNavList((current) => !current)
    setShowResumeMenu(false)
  }
  const hideNavList = () => {
    setShowNavList(false)
    setShowResumeMenu(false)
  }
  const toggleResumeMenu = () => setShowResumeMenu((current) => !current)
  const closeResumeMenu = () => setShowResumeMenu(false)
  const handleResumeTriggerKeyDown = (event) => {
    if (event.key === 'ArrowDown') {
      event.preventDefault()
      setShowResumeMenu(true)
      firstResumeLinkRef.current?.focus()
    }
  }

  useEffect(() => {
    if (!showResumeMenu) return undefined

    const handleDocumentClick = (event) => {
      if (!resumeMenuRef.current?.contains(event.target)) {
        setShowResumeMenu(false)
      }
    }

    const handleDocumentKeyDown = (event) => {
      if (event.key === 'Escape') {
        setShowResumeMenu(false)
      }
    }

    document.addEventListener('mousedown', handleDocumentClick)
    document.addEventListener('touchstart', handleDocumentClick)
    document.addEventListener('keydown', handleDocumentKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleDocumentClick)
      document.removeEventListener('touchstart', handleDocumentClick)
      document.removeEventListener('keydown', handleDocumentKeyDown)
    }
  }, [showResumeMenu])

  const sectionLinks = [
    { shouldShow: true, href: '/sxsw', label: 'SXSW' },
    { shouldShow: jobs.length, href: '#jobs', label: 'Jobs' },
    { shouldShow: educationList.length, href: '#education', label: 'Education' },
    { shouldShow: skills.length, href: '#skills', label: 'Skills' },
    { shouldShow: tools.length, href: '#tools', label: 'Tools' },
    {
      shouldShow: contact.emailCipher || contact.github || contact.linkedin,
      href: '#contact',
      label: 'Contact',
    },
  ].filter((link) => link.shouldShow)

  return (
    <nav className='center nav'>
      <ul
        style={{ display: showNavList ? 'flex' : null }}
        className='nav__list'
      >
        {sectionLinks.map(({ href, label }) => (
          <li key={href} className='nav__list-item'>
            <a
              href={href}
              onClick={hideNavList}
              className='link link--nav'
            >
              {label}
            </a>
          </li>
        ))}

        <li
          ref={resumeMenuRef}
          className={`nav__list-item nav__list-item--resume${
            showResumeMenu ? ' is-open' : ''
          }`}
        >
          <button
            type='button'
            className='link link--nav nav__resume-trigger'
            aria-haspopup='true'
            aria-controls={resumeMenuId}
            aria-expanded={showResumeMenu}
            onClick={toggleResumeMenu}
            onKeyDown={handleResumeTriggerKeyDown}
          >
            <span className='nav__resume-label'>Resume</span>
            <span className='nav__resume-caret' aria-hidden='true'>
              ▼
            </span>
          </button>
          <ul
            id={resumeMenuId}
            className='nav__resume-menu'
            aria-label='resume links'
          >
            <li className='nav__resume-menu-item'>
              <a
                ref={firstResumeLinkRef}
                href={plainResumePdf}
                target='_blank'
                rel='noopener noreferrer'
                className='link link--nav nav__resume-link'
                onClick={hideNavList}
              >
                Plain
              </a>
            </li>
            <li className='nav__resume-menu-item'>
              <a
                href={fancyResumePath}
                className='link link--nav nav__resume-link'
                onClick={hideNavList}
                onKeyDown={(event) => {
                  if (event.key === 'Escape') {
                    closeResumeMenu()
                  }
                }}
              >
                Fancy
              </a>
            </li>
          </ul>
        </li>
      </ul>

      <button
        type='button'
        onClick={toggleTheme}
        className='btn btn--icon nav__theme'
        aria-label='toggle theme'
      >
        {themeName === 'dark' ? (
          <SunIcon className='nav__icon' />
        ) : (
          <MoonIcon className='nav__icon' />
        )}
      </button>

      <button
        type='button'
        onClick={toggleNavList}
        className='btn btn--icon nav__hamburger'
        aria-label='toggle navigation'
      >
        {showNavList ? (
          <CloseIcon className='nav__icon' />
        ) : (
          <MenuIcon className='nav__icon' />
        )}
      </button>
    </nav>
  )
}

export default Navbar
